// Alfabeto de um telefone escrito por extenso: dígitos, espaço e a pontuação
// que separa DDI/DDD. Qualquer caractere fora disso (uma letra, um emoji) é
// prova de que o campo carrega um nome de verdade, mesmo que os dígitos
// coincidam com os do telefone.
const NON_PHONE_CHARACTER = /[^\d\s+()\-.]/;

const digitsOf = value => String(value ?? '').replace(/\D/g, '');

/**
 * Contato do WhatsApp sem nome salvo na agenda chega com `name` IGUAL ao
 * `phone_number` — mesmos dígitos, formatação diferente (`5547999660243` e
 * `+5547999660243`). O card mostrava os dois em linhas separadas: duas
 * linhas para dizer a mesma coisa, na maioria dos cards do board.
 *
 * A comparação é por dígitos (a formatação diverge sempre) E exige que o
 * nome não tenha nenhum caractere fora do alfabeto de telefone: um contato
 * chamado `Angela 5547999660243` tem exatamente os mesmos dígitos do
 * telefone e NÃO é redundante — colapsar ali apagaria "Angela", a única
 * informação que o card tinha além do número.
 *
 * Quando o nome está vazio, o telefone é o título: um botão sem nome
 * acessível é violação de 4.1.2, e a linha do telefone sozinha não rotula
 * controle nenhum.
 *
 * @param {Object} contact contato do card (`name`, `phone_number`).
 * @returns {{title: string, phone: string|null}} título da linha principal e
 *   o telefone a mostrar em linha própria — `null` quando ele apenas
 *   repetiria o título.
 */
export const contactCardIdentity = contact => {
  const name = String(contact?.name ?? '').trim();
  const phone = String(contact?.phone_number ?? '').trim();

  if (!phone) return { title: name, phone: null };

  const phoneIsTheName =
    !name ||
    (!NON_PHONE_CHARACTER.test(name) && digitsOf(name) === digitsOf(phone));

  return phoneIsTheName
    ? { title: phone, phone: null }
    : { title: name, phone };
};
